import React, { Component } from 'react';

export class Contributing extends Component {
    render() {
        return (
            <div className="main-content">
                <div className="content-container">
                    <div className="center-content">
                        <h2>Contributing</h2>
                        <section>
                            <h4>Filing issues</h4>
                            <p>Please file issues through the GitHub issues for the specific project you're working with.</p>
                        </section>
                        <section>
                            <h4>How to Become a Contributor</h4>
                            <p>
                                Some large companies require individuals to sign an agreement prior to accepting their changes. We’ll probably end up doing something like this, but at the moment we’re exploring options that might make it easier for you to contribute. Please stay tuned…
                            </p>
                        </section>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/Contributing.js